function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
export {
  _assertThisInitialized as default
};
//# sourceMappingURL=assertThisInitialized.es.js.map
